<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div [hidden]="pgLoad">
      <div class="adjust loader-container">
    <div class="loader2"></div>
</div>
    </div>
    <div class="col-md-12" [hidden]="!pgLoad">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
            <li *ngIf="loginBusinessCategory != 'Provider'"><a>Manage</a></li>
            <li *ngIf="loginPersonType == 'EMPLOYEE'"><a>Business</a></li>
            <li *ngIf="loginPersonType == 'EMPLOYEE'"><a>Business Entities</a></li>
            <li *ngIf="loginBusinessCategory != 'Provider' && loginPersonType != 'EMPLOYEE'"><a>Your Business</a></li>
            <li *ngIf="loginPersonType == 'EMPLOYEE' && loginBusinessCategory == 'Provider'"><a>Provider Businesses</a></li>
            <li *ngIf="loginPersonType == 'EMPLOYEE' && loginBusinessCategory == 'Provider'"><a>Provider Farm Business Locations</a></li>
            <li *ngIf="loginBusinessCategory == 'Provider'"><a>Your Customers</a></li>
            <li><a>Locations</a></li>
            <li><a>Ponds</a></li>
          </ul>
        <div class="page-breadcrumb__icons">
          <a *ngIf="navFarmProviderId" (click)="navigateBackWithProvider()">
            <img src="../../../../../../../assets/images/New_Icons/back-transprent-icon.svg" title="Back">
          </a>

          <a *ngIf="!navFarmProviderId" (click)="navigateBackWithoutProvider()">
            <img src="../../../../../../../assets/images/New_Icons/back-transprent-icon.svg" title="Back">
          </a>

          <a (click)="navigateToHome()">
            <img src="../../../../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home">
          </a>
        </div>
      </div>
      <div class="block">
        <div class="row business_info_container">
          <div class="business_info_details">
            <div class="business_name_div">
              <span>{{farmSite && farmSite.farmNameAtLocation}}</span><br>
            </div>
            <div class="business_info">
              <div class="business_address_div">
                <span>
                  {{(farmSite && farmSite.address && farmSite.address.village) == '' || (farmSite && farmSite.address && farmSite.address.village) == null ? 'NA' : farmSite && farmSite.address && farmSite.address.village}}
                  ,{{(farmSite && farmSite.address && farmSite.address.state) == '' || (farmSite && farmSite.address && farmSite.address.state) == null ? 'NA' : farmSite && farmSite.address && farmSite.address.state}}
                </span>
              </div>
              <div class="business_email_div">
                <img src="../../../../../../../assets/images/New_Icons/property-type-icon.svg">
                <span>{{(farmSite && farmSite.ownership == '' || farmSite && farmSite.ownership == null) ? 'NA' : (farmSite && farmSite.ownership)}}</span>
              </div>
              <div class="business_email_div">
                <img src="../../../../../../../assets/images/New_Icons/water-type-icon.svg">
                <span>{{((farmSite && farmSite.waterType && farmSite.waterType.name) == '' || (farmSite && farmSite.waterType && farmSite.waterType.name) == null) ? 'NA' : farmSite && farmSite.waterType && farmSite.waterType.name}}</span>
              </div>
              <div class="business_mobile_number_div">
                <img src="../../../../../../../assets/images/New_Icons/soil-type-icon.svg">
                <span>{{((farmSite && farmSite.soilType && farmSite.soilType.name) == '' || (farmSite && farmSite.soilType && farmSite.soilType.name) == null) ? 'NA' : farmSite && farmSite.soilType && farmSite.soilType.name}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="cards_container">
          <div class="card_wrapper" *ngFor="let eachaactivedocdata of customerPondsList; let i = index">
            <div class="each_card_div">
              <div class="card_content">
                <div class="card_header">
                  <div class="img_cum_business_name_div">
                    <img src="../../../../../../../assets/images/New_Icons/card-heading.svg">
                    <span>{{((eachaactivedocdata && eachaactivedocdata.name) == '' || (eachaactivedocdata && eachaactivedocdata.name) == null) ? 'NA' : (eachaactivedocdata && eachaactivedocdata.name)}}</span>
                  </div>
                  <span
                    class="business_type_heading">{{isPondActive(eachaactivedocdata) ? 'Active' : 'Inactive'}}</span>
                </div>
                <div class="card_body">
                  <div>
                    <span>Section:</span>
                    <span>{{((eachaactivedocdata && eachaactivedocdata.PondSection && eachaactivedocdata.PondSection.section_name) == '' || (eachaactivedocdata && eachaactivedocdata.PondSection && eachaactivedocdata.PondSection.section_name) == null) ? 'NA' : eachaactivedocdata && eachaactivedocdata.PondSection && eachaactivedocdata.PondSection.section_name}}</span>
                  </div>
                  <div>
                    <span>Culture:</span>
                    <span>{{eachaactivedocdata && eachaactivedocdata.PondCultureData[0] && eachaactivedocdata.PondCultureData[0].cultureCategory && eachaactivedocdata.PondCultureData[0].cultureCategory.name}}</span>
                  </div>
                  <div>
                    <span>Days:</span>
                    <span
                      class="description">{{eachaactivedocdata.PondCultureData[0] && (getDiffdaysfromtoday(eachaactivedocdata.PondCultureData[0]) + 1)}}</span>
                  </div>
                  <div>
                    <span>Start Date:</span>
                    <span
                      class="description">{{eachaactivedocdata && eachaactivedocdata.PondCultureData[0] && eachaactivedocdata.PondCultureData[0].start_date}}</span>
                  </div>
                </div>
              </div>
              <div class="card_footer">
                <div class="separate_field">
                  <span class="field_text"></span>
                  <span class="field_value_text"></span>
                </div>
                <div class="activities_icons" *ngIf="loginPersonType != 'Provider Manager'">
                  <a style="padding: 10px;">
                    <img src="../../../../../../../assets/images/New_Icons/delete-icon.svg" class="activities_images" title="Delete Pond" (click)="getPondRelatedData(eachaactivedocdata.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div class="col-md-3 col-sm-12 col-xs-12" *ngIf=" customerPonds && customerPonds.length == 0"
             style="margin-top: 20px;">
          <h1>No Data</h1>
        </div>
      </div>
      <!--model popup-->
      <!-- Modal -->
      <div class="modal fade right" id="myModal" role="dialog" data-backdrop="static">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button"   title="Close Popup" class="close" (click)="clear()" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <form>
                
              </form>
            </div>
            <div class="modal-footer">
              <button class="cancel-button" (click)="clear()" data-dismiss="modal">
                <span class="icon"><img src="../../../../../../../assets/images/New_Icons/cross-icon.svg"></span>
                <span class="text">Cancel</span>
              </button>
              <button class="cancel-button" (click)="deletePond()">
                <span class="icon"><img class="delete-icon"
                                        src="../../../../../../../assets/images/New_Icons/delete-icon.svg"></span>
                <span class="text">Delete</span>
              </button>
            </div>
          </div>

        </div>
      </div>
      <!--model popup end-->

       <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': 3 <= 7, 'slide-in-overlay': 3 > 7}" *ngIf="showForm">
        <!--<div *ngIf="formFieldCount > 7" class="overlay-background" (click)="closeForm()"></div>-->
        <!--outside close-->
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
          <!-- Actual Popup -->
          <div [ngClass]="{ 'form-container-panel': 3 > 7, 'popup-inner': 3 <= 7}">
              <div class="form-header">
                <div class="form-title">Pond</div>
                <button class="add-update-submit-button" (click)="deletePond()">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg"></span>
                  <span class="text">Delete</span>
                </button>
              </div>
              <div class="form-container">
                <mat-radio-group [(ngModel)]="selectedDeletedataType" name="deleteType" class="d-block">
                  <mat-radio-button class="d-block" [value]="'False'">
                    <label>Delete Culture Data</label>
                  </mat-radio-button>

                  <mat-radio-button class="d-block" [value]="'True'">
                    <label>Delete Culture Data && Pond</label>
                  </mat-radio-button>
                </mat-radio-group>
                <div style="margin-top: 1rem;padding-left: 1rem;">
                  <h3 style="margin-bottom: 1rem;font-size: medium;font-weight: 500;">Pond Details: </h3>
                  <ul class="deletepondData" *ngFor="let list of imageDetails">
                    <li>Meal records: {{ list.meals }}</li>
                    <li>Check tray Records: {{ list.check_tray }}</li>
                    <li>Sampling Records: {{ list.sampling }}</li>
                    <li>Harvest Records: {{ list.harvest }}</li>
                    <li>Observation Records: {{ list.observation }}</li>
                    <li>Water Quality Records: {{ list.water_quality }}</li>
                  </ul>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
